import { useState } from 'react';
import { HiOutlineDocumentDuplicate } from 'react-icons/hi';
import { BsFillCircleFill } from 'react-icons/bs';
import { BsArrowLeftSquare } from "react-icons/bs";
import { AiOutlineLayout } from "react-icons/ai";
import { removeGroup, duplicateGroupInApi, setDynamicModalObj2 } from "../../store/grupo.actions";
import { useSelector } from 'react-redux';
import { Menu, MenuItem, Typography } from '@mui/material';

export function GroupMenuModal({ dynamicModalObj }) {
    const boards = useSelector(storeState => storeState.boardModule.boards);
    const [anchorEl, setAnchorEl] = useState(null);
    const [hoveredBoardId, setHoveredBoardId] = useState(null); // Estado para rastrear el tablero que está siendo hover
    const currentBoardId = dynamicModalObj.group.fk_tableros_id;

    console.log(boards);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const onSelectBoard = (boardId) => {
        removeGroup(dynamicModalObj.group.id_grupo, boardId);
        dynamicModalObj.isOpen = false;
        setDynamicModalObj2(dynamicModalObj);
        handleClose();
    };

    const onDuplicateGroup = () => {
        try {
            duplicateGroupInApi(dynamicModalObj.group.fk_tableros_id, dynamicModalObj.group.id_grupo);
            dynamicModalObj.isOpen = false;
            setDynamicModalObj2(dynamicModalObj);
        } catch (err) {
            console.log('Error duplicating group:', err);
        }
    };

    const openPaletteModal = () => {
        dynamicModalObj.type = 'palette-modal';
        setDynamicModalObj2({ ...dynamicModalObj });
        
    };

    return (
        <section className="group-menu-modal" style={{ border: '2px solid #ddd', padding: '10px', borderRadius: '8px' }}>
            <div className='color' onClick={openPaletteModal}>
                <BsFillCircleFill style={{ color: 'yellow' }} />
                <span>Cambiar color de grupo</span>
            </div>
            <div className="duplicate" onClick={onDuplicateGroup}>
                <HiOutlineDocumentDuplicate />
                <span>Duplicar este grupo</span>
            </div>
            <div className="delete" onClick={handleClick}>
                <BsArrowLeftSquare />
                <span>Mover A</span>
            </div>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                PaperProps={{
                    style: {
                        borderRadius: '10px',
                        boxShadow: '0px 3px 5px rgba(0,0,0,0.2)',
                        padding: '10px',
                    },
                }}
            >
                {boards.map(board => (
                    <MenuItem
                        key={board.id_tablero}
                        onClick={() => onSelectBoard(board.id_tablero)}
                        onMouseEnter={() => setHoveredBoardId(board.id_tablero)}
                        onMouseLeave={() => setHoveredBoardId(null)}
                        style={{
                            display: 'flex',
                            backgroundColor: board.color, // Color de fondo del tablero
                            
                            opacity: board.id_tablero === currentBoardId ? 0.5 : (hoveredBoardId === board.id_tablero ? 0.8 : 1),
                            pointerEvents: board.id_tablero === currentBoardId ? 'none' : 'auto',
                            transition: 'opacity 0.4s, color 0.3s', // Transición para suavizar el hover
                            color: '#ffffff'
                        }}
                    >
                        <AiOutlineLayout style={{ marginRight: '8px' }} />
                        <Typography variant="body2">{board.nombre_tablero}</Typography>
                    </MenuItem>
                ))}
            </Menu>
        </section>
    );
}
